import { render, staticRenderFns } from "./newCenter.vue?vue&type=template&id=3748644b&scoped=true&"
import script from "./newCenter.vue?vue&type=script&lang=js&"
export * from "./newCenter.vue?vue&type=script&lang=js&"
import style0 from "./newCenter.vue?vue&type=style&index=0&id=3748644b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748644b",
  null
  
)

export default component.exports